import React from 'react'
import PostLayout from './postLayout'

function PortfolioPostmortem() {
    return (
        <PostLayout     
            title="Portfolio Postmortem"
            date="March 10th, 2022"
            author="Aondre"
            image='\images\photo-1518563259479-d003c05a6507-blogpost2-1.jpeg'
            images='\images\secondPost\second_blogpost_500w.jpeg 500w, \images\secondPost\second_blogpost_1000w.jpeg 1000w'
        >
            <p>I recently finished my portfolio/blog site. I’m excited about getting it done but It’s lacking in projects…
                images, color, character, cool features. I don’t even have a way to contact me included… Oh god. Still, it’s
                finished, but of course, far from done.</p>
            <p>One of the coolest things I’ve learned is called, MVP or minimal viable product. Wikipedia defines this
                as, “a version of a product with just enough features to be usable by early customers who can then provide
                feedback for future product development". I have this horrible perfectionist streak going but MVP helped me
                work through that.</p>
            <p>Now that’s it is done I wanted to break down what you’re clicking around just in case anyone is curious
                about what I did and how.</p>
            <p>I used a few things to create this app: HTML, CSS, JavaScript, ReactJS, Bootstrap 5, & I used Netlify to
                host the app. Let’s break this down a bit.</p>
            <p>HTML or Hyper-Text Markup Language provides the structure on many web pages. Example of HTML in the browser:</p>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-10'>
                        <img style={{ width: '100%' }} src='\images\HTML_noCSS.png' alt='HTML with no CSS' />
                    </div>
                </div>
            </div>
            <p className='mt-5'>CSS or Cascading Style Sheets provides the styles we all see and love to web pages and apps. Example of
                CSS used with HTML in the browser:</p>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-10'>
                        <img style={{ width: '100%' }} src='\images\Styled_HTML_page.png' />
                    </div>
                </div>
            </div>
            <p className='mt-5'>JavaScript, a programming language, provides the functionality to websites and apps.</p>
            <p>ReactJS is a JavaScript library developed by Facebook and thank God. It makes JavaScript easier and more manageable.</p>
            <p>BootStrap 5 is an incredibly popular CSS Framework. It takes a mobile first approach and this means that Bootstrap 5 makes
                it so you can develop User interfaces or styles, for both mobile devices and PC monitors.</p>
            <p>Netlify is an awesome platform but I’m only using it to host my app. What I’ve done is take a build or a snapshot of what
                I’ve coded and uploaded that to Netlify. After purchasing the domain name, “aondrefranklin.com” and linking it to my Netlify
                app you’re able to type in domain name that will take you to my app instead of the generic Netlify domain name.</p>
            <p>That’s it. This is what I used to create my site. I hope that made some sense and satiated your curiosity.</p>
            <p>Thanks for reading!</p>
      </PostLayout>
  )
}

export default PortfolioPostmortem